<template>
  <v-form v-model="valid" ref="DialogForm">
    <slotted-dialog :title="$t('servicesystem.common_objects.document.upload')" :externaltrigger="dialogtrigger"
      :externalCloseTrigger="closetrigger">

      <template v-slot:content>
        <v-container :key="dialogtrigger" class="pa-4" style="background-color: #f3f3f3;">
          <v-row no-gutters v-if="!uploadType">
            <v-col>
              <v-card class="d-flex flex-column align-center px-4 py-8 rounded-lg optioncard" elevation="4"
                height="100%" @click="() => { $emit('PickFiles'); closetrigger++; }"> <!-- uploadType = 'file' -->
                <v-icon color="primary" size="70" class="mb-2">mdi-file-upload</v-icon>
                <h3 class="mb-1">{{ $t('servicesystem.common_objects.document.upload_file') }}</h3>
                <p class="text-center">
                  <small>{{ $t('servicesystem.common_objects.document.upload_file_hint') }}</small>
                </p>
              </v-card>
            </v-col>
            <v-col cols="auto" class="d-flex align-center mx-2">
              {{ $t('servicesystem.common_objects.commonterms.or') }}
            </v-col>
            <v-col>
              <v-card class="d-flex flex-column align-center px-4 py-8 rounded-lg optioncard" elevation="4"
                height="100%" @click="uploadType = 'link'">
                <v-icon color="success" size="70" class="mb-2 mr-3">mdi-link-variant</v-icon>
                <h3 class="mb-1">{{ $t('servicesystem.common_objects.document.link_external_content') }}</h3>
                <p class="text-center">
                  <small>{{ $t('servicesystem.common_objects.document.link_external_content_hint') }}</small>
                </p>
              </v-card>
            </v-col>
          </v-row>

          <v-form v-else v-model="valid">
            <v-row v-for="(item, index) in externalContent" :key="index + '-' + clearKey">
              <v-col cols="12">
                <v-card class="pa-3 pt-1">
                  <v-row no-gutters>
                    <QTextField v-model="item.Name" :label="$t('servicesystem.common_objects.document.name')"
                      :rules="[requiredRule]" externaledit :maxlength="limitName ? 50 : undefined">
                    </QTextField>
                    <v-btn v-if="externalContent.length > 1" icon class="mr-n2" @click="removeItem(index)">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-row>
                  <v-row no-gutters class="my-2">
                    <QTextArea v-model="item.Content" :label="$t('servicesystem.common_objects.document.link_url')"
                      :rules="[requiredRule]" externaledit>
                    </QTextArea>
                  </v-row>
                  <v-row no-gutters>
                    <QSwitchInput v-model="item.PublishToCustomer"
                      :label="$t('servicesystem.common_objects.document.visible_for_customer')">
                    </QSwitchInput>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn text color="success" style="text-transform: none; height: 24px"
                  @click="externalContent.push({ Name: '', Content: '' })">
                  <v-icon size="16">mdi-plus</v-icon>
                  {{ $t('servicesystem.common_objects.commonterms.add_more') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>

        </v-container>
      </template>

      <template v-slot:buttons>
        <v-btn color="close" outlined v-text="$t('servicesystem.common_objects.commonterms.cancel')"
          @click=" closetrigger++">
        </v-btn>
        <v-btn v-if="uploadType" :disabled="!valid" :color="'primary'" @click="valid ? save() : null">
          {{ $t('servicesystem.common_objects.document.upload') }}
        </v-btn>
      </template>
    </slotted-dialog>
  </v-form>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";

export default {
  name: "UploadDialog2",
  props: {
    externaltrigger: Number,
    limitName: Boolean, //JobDocument and MachineDocument2 tables have a 50 char limit for the Name field
  },
  components: {
    SlottedDialog,
  },
  mixins: [clientAPI],

  data() {
    return {
      dialogtrigger: 0,
      closetrigger: 0,

      valid: false,
      loading: false,

      uploadType: null,
      externalContent: null,
      clearKey: 1,
    };
  },

  methods: {
    SetDefaults() {
      this.externalContent = [{ Name: '', Content: '', PublishToCustomer: false }];
      this.uploadType = null;
    },

    removeItem(index) {
      this.externalContent.splice(index, 1);
      this.clearKey++;
    },

    save() {
      this.$emit('ExternalContent', this.externalContent);
      this.closetrigger++;
    },
  },

  computed: {

  },

  watch: {
    externaltrigger: function () {
      this.SetDefaults();
      this.dialogtrigger++;
      console.log('UploadDialog2 externaltrigger', this.limitName);
    },
  },
};
</script>